import type { ReactNode } from 'react'
import { cn } from '../../lib/cn'

export interface SectionTitleProps {
  title: string
  /** Optional right-side slot (e.g. a button or counter) */
  children?: ReactNode
  className?: string
}

export const SectionTitle = ({
  title,
  children,
  className,
}: SectionTitleProps) => (
  <div className={cn('flex flex-col gap-2.5', className)}>
    <div className='h-px bg-edu-stroke-default' aria-hidden='true' />
    <div className='flex min-h-12 items-center justify-between'>
      <h2 className='m-0 text-[20px] leading-[1.4] font-semibold tracking-[-0.01em] text-white md:text-title-3 md:leading-title-3'>
        {title}
      </h2>
      {children}
    </div>
  </div>
)
